import Document from "@/models/document.model";
import ApiService from "@/services/api.service";

class DocumentService extends ApiService {
    constructor() {
        super();
    }

    public async getAllDocuments(): Promise<Document[]> {
        const url = "/api/Documents";
        const response = await this.axiosInstance.get<string[]>(url);
        return response.data.map((item) => new Document({name: item}));
    }
    public async GetDocumentByName(fileName: string): Promise<Document> {
        const url = "/api/Documents/" + fileName;
        const response = await this.axiosInstance.get<any>(url, {responseType: "blob"});
        return new Document({name: fileName, fileData: response.data, contentType: response.headers["content-type"]});
    }
}
export default new DocumentService();
